import { Theme } from '@mui/material/styles';

export default function ControlLabel(theme: Theme) {
  return {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginTop: theme.spacing(1),
        },
      },
    },
  };
}
